<template>
  <div class="home-sns-player-select-page">
    <header-pane
      class="home-page__header"
      colorType="light"
      :pageTitle="$tc('HomePage.pageTitle')"
    />

    <sub-header-section :pageTitle="$tc('HomeSnsPlayerSelectPage.pageTitle')" backLink="/home" />

    <home-sns-player-select-pane
      class="home-sns-player-select-page__content"
      @changed="moveToHome"
    />

    <global-navigation-pane current="home" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'
import HeaderPane from '@/components/common/Header/HeaderPane.vue'
import SubHeaderSection from '@/components/common/Header/SubHeaderSection.vue'
import HomeSnsPlayerSelectPane from '@/components/HomeSnsPlayerSelectPage/HomeSnsPlayerSelectPane.vue'
import GlobalNavigationPane from '@/components/common/GlobalNavigation/GlobalNavigationPane.vue'

export type DataType = {
  screenTransitionModal: boolean
  screenTransitionTo: string
}

/**
 * HOME: SNS投稿表示選手選択ページ
 */
export default defineComponent({
  name: 'HomeSnsPlayerSelectPage',
  components: {
    HeaderPane,
    SubHeaderSection,
    HomeSnsPlayerSelectPane,
    GlobalNavigationPane,
  },
  data(): DataType {
    return {
      screenTransitionModal: false, // 画面遷移警告モーダル表示フラグ
      screenTransitionTo: '', // 画面遷移警告モーダル 遷移先指定
    }
  },
  methods: {
    /**
     * HONE画面に遷移する
     */
    moveToHome(): void {
      this.$router.replace({ name: 'HomePage' })
    },
  },
})
</script>
<style lang="scss" scoped>
.home-sns-player-select-page {
  background: $gray1;
  min-height: var(--screen-height);
  padding-bottom: var(--safe-area-inset-bottom);
}
</style>
